import {Component, Vue} from 'vue-property-decorator'
import PictureInput from 'vue-picture-input'
import alertComponent from '../../../components/alert/alert.vue'
import textInput from '../../../components/text-input/text-input.vue'
import { mapState } from 'vuex'
import { ISession } from '../../../types'
import { validPassword, isBetween, isGreaterThan } from '../../../helper-functions/validators'

@Component({
  components: {
    PictureInput,
    alertComponent,
    textInput
  },
  computed: mapState({
    UserId: (state: {session: ISession}) => state.session.UserId,
    UserName: (state: {session: ISession}) => state.session.username,
  })
})

export default class Manage extends Vue {

  private namespace: string = '/Manage';

  private UserId!: string;

  private currentPassword: string = '';

  private newPassword: string = '';

  private newPasswordMatched: string = '';

  private businessName: string = '';

  private alertMessage: string = '';

  private logo: any = null;
  
  private changePassword: boolean = false;

  private changeBusinessName: boolean = false;

  private uploadImage: boolean = false;

  private error: boolean = false;

  private businessDisabled: boolean = false;

  private passwordDisabled: boolean = false;

  private get Email () {

    return this.$store.state.session.email instanceof Array
      ? this.$store.state.session.email[0]
      : this.$store.state.session.email;
  }

  private get UserName () {

    return this.$store.state.session.username instanceof Array
      ? this.$store.state.session.username[0]
      : this.$store.state.session.username;
  }

  private get BusinessName () {

    return this.$store.state.session.fullName;
  }

  private get ValidBusinessName (): boolean {

    return isBetween(100, 3, this.businessName);
  }

  private get ValidPassword (): boolean {

    return validPassword(this.newPassword, this.UserName);
  }

  private get ConfirmedPassword (): boolean {

    return this.newPassword != '' && this.newPassword === this.newPasswordMatched;
  }

  private get businessEnabled () {
    
    return this.businessName != null
      && this.businessName !== ''
        && isBetween(100, 3, this.businessName)
          && !this.businessDisabled;
  }

  private get passEnabled () {
    
    return this.currentPassword != null
      && this.currentPassword !== ''
        && this.ValidPassword
          && this.ConfirmedPassword
            && !this.passwordDisabled;
  }

  private toggleOptions (form: string) {

    if (form === 'image-upload') {
      
      return this.uploadImage = !this.uploadImage;
    }

    if (form === 'business-name') {

      return this.changeBusinessName = !this.changeBusinessName;
    }

    return this.changePassword = !this.changePassword;
  }

  private alertReset () {

    setTimeout(() => {

      if (this.error) {

        this.error = !this.error;
      }

      return this.alertMessage = ''; 
    }, 5000);
  }

  private async updateBusinessName () {

    try {

      const response = await this.$axios.get(`${this.$apiUrl + this.namespace}/UpdateFullName`, {
        params: {
          userId: this.UserId,
          fullName: this.businessName
        }
      })
      
      this.alertMessage = 'Name successfuly updated!';
      this.$store.commit('createSession', response.data);
      this.toggleOptions('business-name');
      this.alertReset();

    } catch (err) {

      this.alertMessage = this.$t('errors.general') as string;
      this.error = !this.error;
      this.alertReset();
    }
  }

  private async updatePassword () {

    try {
      const response = await this.$axios.post(`${this.$apiUrl + this.namespace}/ChangePassword`, {
        OldPassword: this.currentPassword,
        NewPassword: this.newPasswordMatched
      })

      this.alertMessage = 'Password updated successfuly!';
      this.toggleOptions('password');
      this.alertReset();
    } catch (err) {
      
      this.alertMessage = this.$t('errors.general') as string;
      this.error = !this.error;
      this.alertReset();
    }
  }
}